import { FaCoffee, FaTasks, FaTools, FaUsers } from "react-icons/fa";
import {
  FaChartPie,
  FaSquarePen,
  FaChartSimple,
  FaGear,
  FaUser,
  FaAddressCard,
} from "react-icons/fa6";
import { BiSolidLogOut } from "react-icons/bi";
import { BsListOl } from "react-icons/bs";


function IconMaker(iconName: string, margin: boolean) {
  let icon;
  switch (iconName) {
    case "FaChartPie":
      icon = (
        <FaChartPie
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaSquarePen":
      icon = (
        <FaSquarePen
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaChartSimple":
      icon = (
        <FaChartSimple
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaGear":
      icon = (
        <FaGear
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaTasks":
      icon = (
        <FaTasks
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "BiSolidLogOut":
      icon = (
        <BiSolidLogOut
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaUserCheck":
      icon = (
        <FaUser
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaTools":
      icon = (
        <FaTools
          color="#FFF"
          size={18}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaUsers":
      icon = (
        <FaUsers
          color="#FFF"
          size={18}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "BsListOl":
      icon = (
        <BsListOl
          color="#FFF"
          size={18}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    case "FaAddressCard":
      icon = (
        <FaAddressCard 
          color="#fff"
          size={18}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
      break;
    default:
      icon = (
        <FaCoffee
          color="#FFF"
          size={20}
          style={{ marginRight: margin ? "16px" : "" }}
        />
      );
  }

  return <div>{icon}</div>;
}

export default IconMaker;
